<template>
<CheckboxSelector :label="t('Columns')" v-model="columnsFieldsNames" :options="options" :tabindex="tabindex" :disabled="disabled"/>
</template>

<script>
import CheckboxSelector from './../selectors/CheckboxSelector.vue';
import i18n from '../../i18n';

export default {
    name: 'ColumnsFilter',

    components: {
        CheckboxSelector
    },

    computed: {
        columnsFieldsNames: {
            get () {
                return this.$store.state.columnsFieldsNames;
            },
            set (columnsFieldsNames) {
                this.$store.commit('setColumnsFieldsNames', { columnsFieldsNames });
            }
        },

        options () {
            return this.$store.state.columns.map((column, index) => {
                const option = {
                    text: column.Header,
                    value: column.MatchingFieldName
                };
                if (column.Help) {
                    option.help = column.Help;
                }
                // disable first column (Instrument's name)
                if (index === 0) {
                    option.disabled = true;
                }
                return option;
            });
        },

        disabled () {
            return this.$store.getters.areColumnsLoading ||
                this.options.filter(option => !option.disabled).length === 0;
        },

        tabindex () {
            if (this.disabled) {
                return null;
            }
            if (this.$store.getters.mediaQuery.includes(720)) {
                return 5;
            }
            return 4;
        }
    },

    methods: {
        t (str) {
            return i18n(str, this.$store.state.lang);
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/filters/ColumnsFilter.vue